<template>
  <div class="Date" style="display:inline-block">
    <p class="date">{{ h + ':' + m + ':' + s }}</p>
  </div>
</template>
<script>
export default {
  name: 'CountDown',
  props: ['endDate'],
  data () {
    return {
      h: '',
      m: '',
      s: '',
      loopCount: 0
    }
  },
  created () {
    this.countTime()
  },
  methods: {
    countTime () {
      let curTime = new Date().getTime()
      // 时间差
      let leftTime = this.endDate - curTime
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime > 0) {
        this.h = this.addZero(Math.floor((leftTime / 1000 / 60 / 60) % 24))
        this.m = this.addZero(Math.floor((leftTime / 1000 / 60) % 60))
        this.s = this.addZero(Math.floor((leftTime / 1000) % 60))
        this.loopCount = setTimeout(this.countTime, 1000)
      } else {
        clearTimeout(this.loopCount)
        // 由倒计时转为正在抢
        this.$parent.getSeckillList()
      }
    },
    addZero (i) {
      return i < 10 ? '0' + i : i
    }
  }
}
</script>
